import type { IReportPeriod, IReportUser } from './IReportPeriod'

/** `GET /services/reports/logisticians_involvement` (`SPEC-027` §3.3, §5.2). */
export const LOGISTICIANS_INVOLVEMENT_REPORT_URL = '/services/reports/logisticians_involvement'

/** Дев'ять показників — білий список сортування бека (`LogisticiansInvolvementReportRepository::METRICS`). */
export const LOGISTICIANS_INVOLVEMENT_METRICS = [
    'applicationsCreated',
    'applicationOffers',
    'applicationsConfirmed',
    'applicationsUnloaded',
    'applicationsLost',
    'requestsCreated',
    'requestOffers',
    'tendersCreated',
    'tenderOffers',
] as const

export type LogisticiansInvolvementMetric = (typeof LOGISTICIANS_INVOLVEMENT_METRICS)[number]

export type ILogisticiansInvolvementRow = { user: IReportUser } & Record<LogisticiansInvolvementMetric, number>

/** Підсумку немає ні в легасі, ні в беку (`SPEC-027` §2.2, З-07). */
export interface ILogisticiansInvolvementReport {
    period: IReportPeriod
    rows: ILogisticiansInvolvementRow[]
}
